export default "/images/vendor/flag-icons/flags/4x3/bw.svg?840cd355c0fbd02b11c7ab8746e0d1c3";